module.exports = __webpack_public_path__ + "assets/602b3d0ccb57e1a1d3562c568ea49102.svg";